import React, { useState } from 'react';
import EditIcon from '../../assets/EditIcon';
import { IStaffAllocation } from '../../type/staffAllocation';
import DeleteIcon from '../../assets/DeleteIcon';
import DeleteConfirmation from './DeleteConfirmation';
import operationAPI from '../../api/operationApi';
import { toast } from 'react-toastify';
import { translate } from '../../i18n';
import BallIcon from '../../assets/BallIcon';
import useBgColorStore from '../../store/bgColor';
import EditIconDark from '../../assets/EditIconDark';
import DeleteIconDark from '../../assets/DeleteIconDark';
import {
  COMPLIANCE_STATUS,
  OPERATION_COMPLIANCE,
} from '../../constants/constant';

interface CrewPilotDetailsProps {
  openModal?: any;
  crewList: IStaffAllocation[];
  onOperationStaffIdChange?: (operationStaffId: number) => void;
  onStaffChange: () => void;
}

const CrewPilotDetailsCard: React.FC<CrewPilotDetailsProps> = ({
  openModal,
  crewList,
  onOperationStaffIdChange,
  onStaffChange,
}) => {
  const [editModes, setEditModes] = useState<boolean[]>(
    crewList.map(() => false),
  );
  const { bgColor, updateBgColor } = useBgColorStore();
  const toggleEditMode = (index: number) => {
    const updatedEditModes = [...editModes];
    updatedEditModes[index] = !updatedEditModes[index];
    setEditModes(updatedEditModes);
  };

  // Function to handle checkbox state change
  const handleCheckboxChange = (
    index: number,
    field: 'need' | 'kkd' | 'actualWeight',
  ) => {
    if (editModes[index]) {
      const updatedCrewList = [...crewList];
      updatedCrewList[index] = {
        ...updatedCrewList[index],
        [field]: !updatedCrewList[index][field], // Toggle the checkbox value
      };
      // Update the crewList in state or perform any necessary action here
    }
  };

  const handleOperationStaffIdChange = (
    operationStaffId: number,
    crew?: IStaffAllocation,
  ) => {
    if (onOperationStaffIdChange) {
      onOperationStaffIdChange(operationStaffId);
    }
    openModal('PilotForm', crew);
  };
  const [isModalOpenForDelete, setIsModalOpenForDelete] = useState(false);
  const [selectedOperationStaffId, setSelectedOperationStaffId] = useState<
    number | null
  >(null);
  const [selectedOperationBalloonId, setSelectedOperationBalloonId] = useState<
    number | null
  >(null);
  const openDeleteModal = (
    operationStaffId: number,
    operationBalloonId: number,
  ) => {
    setSelectedOperationStaffId(operationStaffId);
    setSelectedOperationBalloonId(operationBalloonId);
    setIsModalOpenForDelete(true);
  };

  const closeDeleteModal = () => {
    setSelectedOperationStaffId(null);
    setSelectedOperationBalloonId(null);
    setIsModalOpenForDelete(false);
  };

  const confirmDeletion = async () => {
    try {
      if (!selectedOperationStaffId) {
        console.error('No operationStaffId selected for deletion.');
        return;
      }
      const response = await operationAPI.deleteStaff(
        selectedOperationStaffId,
        selectedOperationBalloonId,
      );
      console.log(response);
      toast.success(translate('driver.deleteStaff'));
      onStaffChange();
    } catch (error) {
      console.error('Error deleting item:', error);
      toast.warn(translate('operation.commonError'));
    }
  };

  return (
    <>
      {crewList.map((crew: IStaffAllocation, index) => {
        console.log(crew?.resPhone, 'crew?.resPhone');
        return (
          <div className="mt-4" key={crew.operationStaffId}>
            <div
              className={`bg-backgroundColor-white rounded-lg shadow-md p-5 `}
            >
              {/* Header */}
              <div className="relative group">
                {/* Header Section with Tooltip Trigger */}
                <div
                  className={`flex justify-between items-center mb-4 rounded ${
                    crew?.driverFatigueStyle === COMPLIANCE_STATUS.expired
                      ? 'bg-backgroundColor-fatigueRedColorCode'
                      : crew?.driverFatigueStyle ===
                            COMPLIANCE_STATUS.upcoming ||
                          crew?.driverFatigueStyle === COMPLIANCE_STATUS.current
                        ? 'bg-backgroundColor-fatigueYellowColorCode'
                        : 'bg-backgroundColor-white'
                  }`}
                >
                  <h2 className="text-lg font-semibold text-textColor">
                    {crew.staffName}
                  </h2>

                  <div className="flex justify-between">
                    {/* Delete Button */}
                    <button
                      className="text-textColor hover:text-textColor mr-4"
                      onClick={() =>
                        openDeleteModal(
                          crew?.operationStaffId,
                          crew?.operationBalloonId,
                        )
                      }
                    >
                      <div>
                        <div className="block dark:hidden">
                          <DeleteIcon />
                        </div>
                        <div className="hidden dark:block">
                          <DeleteIconDark />
                        </div>
                      </div>
                    </button>

                    {/* Edit Button */}
                    <button
                      className="text-textColor hover:text-textColor"
                      onClick={() => {
                        toggleEditMode(index); // Toggle edit mode for this specific card
                        handleOperationStaffIdChange(
                          crew.operationStaffId,
                          crew,
                        );
                      }}
                    >
                      <div>
                        <div className="block dark:hidden">
                          <EditIcon />
                        </div>
                        <div className="hidden dark:block">
                          <EditIconDark />
                        </div>
                      </div>
                    </button>
                  </div>
                </div>
                {/* Tooltip */}
                {crew?.driverFatigueMessage?.trim() && (
                  <div className="absolute z-10 hidden group-hover:block bg-white text-gray-800 text-sm border border-customBorder-border rounded shadow-lg p-2 w-64 top-full left-0 mt-1">
                    <p>{crew?.driverFatigueMessage}</p>
                  </div>
                )}
              </div>

              {/* Details Section */}
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-2 text-start text-sm">
                {/* Each row */}
                <div className="flex flex-col">
                  <p className="font-medium text-textColorGray">
                    Qualification
                  </p>
                  <p className="text-textColorGray">
                    {crew.staffqualifications}
                  </p>
                </div>
                <div className="flex flex-col relative group">
                  <p className="font-medium text-textColorGray">Balloon</p>
                  <p
                    className={`text-text-black px-2 py-1 rounded w-[80%]
                      ${
                        crew?.compliantStyle ===
                        OPERATION_COMPLIANCE.statusExpired
                          ? 'bg-backgroundColor-fatigueRedColorCode'
                          : crew?.compliantStyle ===
                                OPERATION_COMPLIANCE.statusUpComing ||
                              crew?.compliantStyle === COMPLIANCE_STATUS.current
                            ? 'bg-backgroundColor-fatigueRedColorCode'
                            : ''
                      }
                    `}
                  >
                    {crew?.formattedBalloonName}
                  </p>

                  {/* Custom Tooltip */}
                  {crew?.complianceMessage && (
                    <div className="absolute z-10 hidden group-hover:block bg-white text-gray-800 text-sm border border-customBorder-border rounded shadow-lg p-2 w-64 top-full left-0 mt-1">
                      <p>{crew?.complianceMessage}</p>
                    </div>
                  )}
                </div>
                <div className="flex flex-col">
                  <p className="font-medium text-textColorGray">
                    Balloon Capacity
                  </p>
                  <p className="text-textColorGray">{crew?.maxPax}</p>
                </div>
                <div className="flex flex-col">
                  <p className="font-medium text-textColorGray">Phone Number</p>
                  <p className="text-textColorGray">
                    {['', 'null', 'undefined', null, undefined].includes(
                      crew?.resPhone,
                    )
                      ? '---'
                      : crew?.resPhone}
                  </p>
                </div>
                <div className="flex flex-col"></div>
                <div className="flex flex-col"></div>
                <div className="space-y-3">
                  <label className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-textColor border-gray-300 rounded focus:ring-blue-400"
                      checked={crew?.need}
                      onChange={() => handleCheckboxChange(index, 'need')}
                      disabled={!editModes[index]} // Disable if not in edit mode
                    />
                    <span className="text-sm text-text-primary">Need</span>
                  </label>
                  <label className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-textColor border-gray-300 rounded focus:ring-blue-400"
                      checked={crew?.kkd}
                      onChange={() => handleCheckboxChange(index, 'kkd')}
                      disabled={!editModes[index]} // Disable if not in edit mode
                    />
                    <span className="text-sm text-text-primary">KK'D</span>
                  </label>
                  <label className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-textColor border-gray-300 rounded focus:ring-blue-400"
                      checked={crew?.actualWeight}
                      onChange={() => {
                        handleCheckboxChange(index, 'actualWeight');
                        setIsModalOpenForDelete(true);
                      }}
                      disabled={!editModes[index]} // Disable if not in edit mode
                    />
                    <span className="text-sm text-text-primary">
                      Actual Weight
                    </span>

                    {crew?.actualWeight ? <BallIcon /> : null}
                  </label>
                </div>
              </div>

              {/* Checkboxes Section */}
            </div>
          </div>
        );
      })}

      {isModalOpenForDelete && (
        <DeleteConfirmation
          isOpen={isModalOpenForDelete}
          onClose={closeDeleteModal}
          onConfirm={confirmDeletion}
          itemName="Pilot"
          operationStaffId={selectedOperationStaffId || undefined}
        />
      )}
    </>
  );
};

export default CrewPilotDetailsCard;
